import React from 'react';
import PropTypes from 'prop-types';

const SolidMapPin = ({ 
  size = 16, 
  className = '', 
  color = 'currentColor',
  ...props 
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    className={className}
    {...props}
  >
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 
    9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
    <line x1="4" y1="22" x2="20" y2="22" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

SolidMapPin.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
};

export default SolidMapPin;